import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Datatable from '../common/datatable'
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";

export class Non_buyer_users extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
        };
    }

    componentWillMount() {
        this.getDataUser();
    }

    getDataUser(){
        var user = AuthService.getCurrentUser();
        ApiService.getNonBuyerUsers(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        return { 
                            id: row.id, 
                            Nombre : row.name + ' ' + row.last_name, 
                            Email : row.email,
                            Celular : row.Profile ? row.Profile.cell_phonenumber : '',
                            Rol : row.role,
                            Embajador: (row.Referred && row.Referred.name?row.Referred.name:'')+' '+(row.Referred && row.Referred.last_name?row.Referred.last_name:''),
                            'Fec. registro': row.date
                        }
                    })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
                const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            }
            );
    }

    renderResults(length){
        return this.state.results.length === 0 
            ? 'No hay datos.'
            : <Datatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=100?length:100}
            pagination={true}
            class="-striped -highlight"
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Usuarios" parent="Users" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Usuarios que nunca han comprado</h5>
                        </div>
                        <div className="card-body">
                            
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete text-left">
                                
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Non_buyer_users;
